import { Card } from "../../../../../components/Card";
import { Text } from "@chakra-ui/react";

function ExposureToLitigationDescription() {
  return (
    <Card>
      <Text marginBottom={5}>
        As ESG risks increase, so do frequencies of litigation and the risk for companies exposed to legal action. This indicator tracks the frequencies of
        litigation in the form of lawsuits and climate related laws and policy.
      </Text>
      <Text marginBottom={5}>
        Exposure to litigation is assessed on a thematic basis and illustrates sentiment surrounding (in)action regarding the pursuit for carbon neutrality.
      </Text>
    </Card>
  );
}

export default ExposureToLitigationDescription;